import React from 'react';
import './Button.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'text' | 'link';
export type ButtonSize = 'small' | 'medium' | 'large';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  /** Shown as a tooltip when the button is disabled (e.g. validation message). */
  disabledReason?: string;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  className = '',
  disabledReason,
  disabled,
  children,
  ...props
}) => {
  const buttonClasses = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    fullWidth && 'btn--full-width',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const button = (
    <button className={buttonClasses} disabled={disabled} {...props}>
      {children}
    </button>
  );

  if (disabled && disabledReason) {
    return (
      <span
        className={['btn-tooltip-wrap', fullWidth && 'btn-tooltip-wrap--full-width']
          .filter(Boolean)
          .join(' ')}
      >
        {button}
        <span className="btn-tooltip" role="tooltip">
          {disabledReason}
        </span>
      </span>
    );
  }

  return button;
};

